module.exports = __webpack_public_path__ + "static/media/Rectangle96.81cbfeb8.png";